var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice"},[(
      (_vm.ChannelModule.channel == 'plat_h5' || _vm.AppSource == 'harmonyOS') &&
      _vm.AppSource !== 'ios'
    )?_c('van-nav-bar',{staticClass:"navbar",attrs:{"title":_vm.title,"left-arrow":"","safe-area-inset-top":true,"placeholder":true},on:{"click-left":_vm.onClickLeft}}):_vm._e(),_c('van-row',{staticClass:"n-main"},[_c('div',{staticClass:"img-con",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }